export type NavSection = 'Admin' | 'User';

/**
 * Honour a stored 'Admin' section only while still admin, else fall back to 'User' — so narrowing
 * away from admin doesn't strand the user in the (now hidden) admin nav.
 */
export const resolveNavSection = (
	stored: string | null,
	isAdmin: boolean,
): NavSection => (stored === 'Admin' && isAdmin ? 'Admin' : 'User');
